module.exports = __webpack_public_path__ + "img/unselect.24422bcb.svg";